<header class="app-topbar">
  <div class="container-fluid topbar-menu">
    <div class="d-flex align-items-center gap-2 my-2">
      <button class="button-collapse-toggle d-xl-none" (click)="toggleSidebar()">
        <ng-icon name="lucideMenu" class="fs-22"></ng-icon>
      </button>

      <!-- Integration profile selector -->
      <div class="topbar-item d-none d-md-flex">
        <app-integration-profile-selector
          [options]="profileState.profileOptions()"
          [selectedValue]="profileState.selectedProfileId()"
          [placeholder]="'topbar.select_profile' | transloco"
          triggerAppearance="compact"
          panelHorizontalAlign="start"
          (selectionChange)="onProfileChange($event)"
        />
      </div>
    </div>

    <div class="d-flex align-items-center gap-2">
      <!-- User info + logout -->
      <div class="topbar-item" ngbDropdown placement="bottom-end">
        <button type="button" class="topbar-link btn shadow-none btn-link px-2" ngbDropdownToggle>
          <span class="d-none d-md-inline me-1">{{ currentUserService.userName() }}</span>
          <ng-icon name="lucideUser" class="fs-xl"></ng-icon>
        </button>
        <div ngbDropdownMenu class="dropdown-menu-end">
          <span class="dropdown-item-text text-muted small">
            {{ currentUserService.userEmail() }}
          </span>
          <button ngbDropdownItem type="button" routerLink="/settings">
            <ng-icon name="lucideSettings" class="fs-15 me-1"></ng-icon>
            {{ 'topbar.settings' | transloco }}
          </button>
          <div class="dropdown-divider"></div>
          <button ngbDropdownItem type="button" (click)="logout()">
            <ng-icon name="lucideLogOut" class="fs-15 me-1"></ng-icon>
            {{ 'topbar.logout' | transloco }}
          </button>
        </div>
      </div>
    </div>
  </div>
</header>
